import { Component, OnInit } from "@angular/core";
import { OrderService } from "../../../service/order.service";
import { HttpErrorResponse } from "@angular/common/http";
import { Message } from "primeng/components/common/api";
import { Router } from "@angular/router";

@Component({
  selector: "app-supplier-order-list",
  templateUrl: "./supplier-order-list.component.html",
  styleUrls: ["./supplier-order-list.component.css"],
})
export class SupplierOrderListComponent implements OnInit {
  orders: any[];
  cols = [
    { field: "OrderNumber", header: "מספר הזמנה", width: "160", priority: "" },
    // { field: 'SupplierName', header: 'שם ספק', width: '200', priority: 'ui-p-1'  },
    { field: "OrderStatus", header: "סטטוס", width: "100", priority: "ui-p-2" },
    {
      field: "OrderDate",
      header: "תאריך הזמנה",
      width: "160",
      priority: "ui-p-3",
    },
    { field: "Destination", header: "יעד", width: "80", priority: "ui-p-6" },
    {
      field: "DestinationName",
      header: "תאור יעד",
      width: "180",
      priority: "ui-p-6",
    },
    {
      field: "DummyButtons",
      header: "",
      width: "120",
      priority: "",
      sortable: false,
    },
  ];
  colsLines = [
    { field: "LineNumber", header: "שורה", width: "50", priority: "" },
    { field: "Catalog", header: 'מק"ט', width: "100", priority: "ui-p-6" },
    { field: "Description", header: "תאור", width: "100", priority: "ui-p-2" },
    { field: "Quantity", header: "כמות", width: "100", priority: "ui-p-2" },
    {
      field: "UnitePrice",
      header: "מחיר ליחידה",
      width: "100",
      priority: "ui-p-5",
    },
    { field: "Currency", header: "מטבע", width: "100", priority: "ui-p-6" },
    {
      field: "DiscountPercent",
      header: "% הנחה",
      width: "100",
      priority: "ui-p-6",
    },
    { field: "Total", header: 'סה"כ לשורה', width: "100", priority: "ui-p-5" },
    {
      field: "QuantityReminder",
      header: "יתרת כמות",
      width: "100",
      priority: "ui-p-5",
    },
    { field: "Balance", header: "יתרה", width: "100", priority: "" },
  ];
  colsInvoices = [
    { field: "InvoiceType", header: "סוג", width: "80", priority: "" },
    {
      field: "InvoiceNumber",
      header: "מספר",
      width: "100",
      priority: "ui-p-1",
    },
    { field: "InvoiceDate", header: "תאריך", width: "100", priority: "ui-p-3" },
    {
      field: "InvoiceStatus",
      header: "סטטוס",
      width: "120",
      priority: "ui-p-2",
    },
    { field: "Quantity", header: "כמות", width: "100", priority: "ui-p-4" },
    {
      field: "UnitePrice",
      header: "מחיר ליחידה",
      width: "100",
      priority: "ui-p-5",
    },
    { field: "Total", header: 'סה"כ לשורה', width: "100", priority: "ui-p-3" },
    {
      field: "TotalWithTax",
      header: "יתרת כמות",
      width: "100",
      priority: "ui-p-4",
    },
  ];

  filterOrderNumber: any;
  // filterSupplier: any;
  filterOrderStatus: any;
  filterDateFrom: any;
  filterDateTo: any;

  suppliersOptions: any[] = [];
  orderStatusOptions: any[] = [];

  msgs: Message[] = [];

  showInvoicePreviewDialog: boolean = false;
  currentInvoiceDetails: any;

  constructor(private orderService: OrderService, private router: Router) { }

  ngOnInit() {
    this.filterOrderNumber = null;

    // this.filterSupplier = null;
    // this.orderService.GetCustomerSuppliers().subscribe((result: any) => {
    //   this.suppliersOptions = result;
    // },
    //   (err: HttpErrorResponse) => {
    //     this.showMessage('error', '', 'תקלה בקבלת רשימת ספקים ');
    // });

    this.filterOrderStatus = null;
    this.orderService.GetSupplierOrderStatuses().subscribe(
      (result: any) => {
        this.orderStatusOptions = result;
        // this.orderStatusOptions.unshift({ label: 'הכל', value: null });
      },
      (err: HttpErrorResponse) => {
        this.showMessage("error", "", "תקלה בקבלת רשימת סטטוסים ");
      },
    );

    let fromD = new Date(new Date().getFullYear(), 0, 1);
    this.filterDateFrom = new Date(
      Date.UTC(fromD.getFullYear(), fromD.getMonth(), fromD.getDate()),
    );
    this.filterDateTo = new Date();

    this.getSupplierOrders();
  }

  getSupplierOrders() {
    let orderFilter = {
      OrderNumber: this.filterOrderNumber,
      //SupplierId: this.filterSupplier ? this.filterSupplier.Id : null,
      OrderStatusId: this.filterOrderStatus,
      OrderDateFrom: this.filterDateFrom
        ? new Date(
          Date.UTC(
            this.filterDateFrom.getFullYear(),
            this.filterDateFrom.getMonth(),
            this.filterDateFrom.getDate(),
          ),
        )
        : null,
      OrderDateTo: this.filterDateTo
        ? new Date(
          Date.UTC(
            this.filterDateTo.getFullYear(),
            this.filterDateTo.getMonth(),
            this.filterDateTo.getDate(),
          ),
        )
        : null,
    };
    this.orderService.getSupplierOrders(orderFilter).subscribe(
      (result: any) => {
        this.orders = result;
      },
      (err: HttpErrorResponse) => {
        let errMessage =
          err.error && err.error.ExceptionMessage
            ? err.error.ExceptionMessage
            : "תקלה בקבלת נתונים ";
        this.showMessage("error", "", errMessage);
      },
    );
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({
      severity: type,
      summary: summaryMessage,
      detail: message,
    });
  }

  showSuccess() {
    this.msgs = [];
    this.msgs.push({
      severity: "success",
      summary: "",
      detail: " העדכון נשמר בהצלחה",
    });
  }

  showError() {
    this.msgs = [];
    this.msgs.push({ severity: "error", summary: "", detail: " שגיאה בעדכון" });
  }

  showFile(invoice) {
    this.currentInvoiceDetails = invoice;
    this.showInvoicePreviewDialog = true;
  }

  isOrderOpen(order: any): boolean {
    return order.OrderStatusId !== 2;
  }
}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/order/supplier-order/supplier-order-list/supplier-order-list.component.ts